import { render, staticRenderFns } from "./OrderDataStudies.vue?vue&type=template&id=f26c30ca&scoped=true"
import script from "./OrderDataStudies.vue?vue&type=script&lang=js"
export * from "./OrderDataStudies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f26c30ca",
  null
  
)

export default component.exports